import { Backdrop, CircularProgress } from '@mui/material';

const Loading = ({ loading }) => (
  <Backdrop sx={{ color: '#fff', zIndex: 2000 }} open={loading}>
    <CircularProgress color="inherit" />
  </Backdrop>
);

export default Loading;
